<template>
  <v-select
    :items="lookupValues"
    :disabled="documentMetadata.metadata.isReadonly"
    v-model="localValue"
    hide-details
    ref="textField"
    item-title="lookupValue"
    item-value="id"
    :label="label"
    :data-cy="documentMetadata.metadata.key"
  ></v-select>
</template>

<script>
import metadataService from "@/services/metadataService";
import metadataMixin from "@/mixins/metadataMixin";
import _ from "lodash";

export default {
  name: "ListMetadata",

  // Use the mixin to handle prop mutations properly
  mixins: [metadataMixin],

  props: {
    // documentMetadata is provided by the mixin
  },

  data() {
    return {
      lookupValues: [],
    };
  },
  computed: {
    // localValue is provided by the mixin and emits events on set
    label() {
      return this.isLineItem ? "" : this.documentMetadata.metadata.name;
    },
  },

  async created() {
    let values = await metadataService.getLookupValues(
      this.documentMetadata.metadata.id,
      this.documentMetadata.metadata.isThirdParty
    );
    this.localValue = isNaN(parseInt(this.documentMetadata.value)) ? null : parseInt(this.documentMetadata.value);
    this.lookupValues = _.sortBy(values, [
      function(o) {
        return o.lookupValue;
      },
    ]);
  },
};
</script>
